import React from 'react';
import PropTypes from 'prop-types';
import { formatPrice } from '../../../../helpers/formatNumbers';

const ItemPrice = ({ isOnSale, lineItemRetail, savingPercentage }) => (
  <div className="updateColumn">
    <span className="columnTitle">Item Price</span>
    {isOnSale && (
      <span className="itemRetail">{formatPrice(lineItemRetail)}</span>
      )}
    <span className="itemSubtotal">{formatPrice((lineItemRetail * (1 - savingPercentage)))}</span>
    <span className="each">Each</span>
  </div>
);

export default ItemPrice;

ItemPrice.propTypes = {
  isOnSale: PropTypes.bool.isRequired,
  lineItemRetail: PropTypes.number.isRequired,
  savingPercentage: PropTypes.number.isRequired,
};
